module.exports = __webpack_public_path__ + "img/logo.bad59674.png";